import { Component, Injectable, ViewChild } from '@angular/core'
import { ModalDirective } from 'ng2-bootstrap/src/modal'

import { ConfirmService } from './confirm.service'
import { ConfirmOptions, ConfirmStyle } from './confirm.options'
import { Subscription } from 'rxjs'

@Component({
  template: require('./confirm.component.html'),
  selector: 'confirm',
  styles: [`
    :host {
      position: absolute;
      z-index: 1200;
    }
    .modal-dialog {
      margin-top: 100px;
    }
  `]
})

@Injectable()
export class ConfirmComponent {
  title: string
  confirmBtnText: string
  cancelBtnText: string
  confirmFn: Function
  cancelFn: Function
  onlyConfirm: boolean
  text: string
  html: string
  style: ConfirmStyle
  @ViewChild('modal') private modal: ModalDirective

  shownSubscription: Subscription
  
  constructor(private confirmService: ConfirmService) {}

  ngOnInit() {
    this.confirmService.getConfirms().subscribe((options: ConfirmOptions) => {
      this.title = options.title
      this.confirmBtnText = options.confirmBtnText
      this.cancelBtnText = options.cancelBtnText
      this.confirmFn = options.confirmFn
      this.cancelFn = options.cancelFn
      this.onlyConfirm = options.onlyConfirm
      this.text = options.text
      this.html = options.html
      this.style = options.style
      this.modal.show()
    })

    this.shownSubscription = this.modal.onShow.subscribe(event => {
      setTimeout(() => {
        let modlaBackDrops = document.querySelectorAll("bs-modal-backdrop")
        modlaBackDrops[modlaBackDrops.length - 1].classList.add('modal-confirm-backdrop')
      }, 0)
    })

    this.modal.onHidden.subscribe(event => {
      setTimeout(() => {
        let modlaBackDrops = document.querySelectorAll("bs-modal-backdrop")
        if (modlaBackDrops.length > 0) {
          let body = document.querySelector("body")
          body.classList.add("modal-open")
        }
      }, 0)
    })
  }

  ngOnDestroy() {
    this.shownSubscription.unsubscribe()
  }

  buttonStyle() {
    switch (this.style) {
      case ConfirmStyle.default:
        return 'btn-success'
      case ConfirmStyle.danger:
        return 'btn-danger'
      default:
        return 'btn-success'
    }
  }

  private confirm() {
    this.modal.hide()
    this.confirmFn()
  }

  private cancel() {
    this.modal.hide()
    this.cancelFn()
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/core/confirm/confirm.component.ts